import { render, staticRenderFns } from "./new-coupon.vue?vue&type=template&id=3b15def8&scoped=true&"
import script from "./new-coupon.vue?vue&type=script&lang=ts&"
export * from "./new-coupon.vue?vue&type=script&lang=ts&"
import style0 from "./new-coupon.vue?vue&type=style&index=0&id=3b15def8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b15def8",
  null
  
)

component.options.__file = "new-coupon.vue"
export default component.exports